import type { AcquirerCopyDto } from "../../types/AcquirerCopyDto";
import type { AcquirerCopyEntity } from "../../types/AcquirerCopyEntity";

export const AcquirerCopyEntityToCopyDto = ({ ...rest }: Readonly<AcquirerCopyEntity>): AcquirerCopyDto => {
    return { ...rest };
};
